// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetSearchTypesRequest, TGetSearchTypesModel, IMappers, TGetSearchTypesResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSearchTypesResponseSchema } from '../../entities/get_search_types/GetSearchTypesResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSearchTypesModel(parameters: IGetSearchTypesRequest): TGetSearchTypesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-promos',
    pathApi: '/v1/get-search-types/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetSearchTypesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSearchTypesRequest;
}

export async function fetchGetSearchTypes<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSearchTypesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSearchTypesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSearchTypesModel(parameters),
    config,
  )) as FetchResponse<TGetSearchTypesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSearchTypesResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSearchTypesResponse>;
}
